<template>
  <listing-layout :style="{ '--apperances-color': computedColor }" no-sm-padding>
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="nominate__title h2 mb-3">{{ event && event.name ? event.name : '' }}</h1>
    </div>
    <div slot="content" class="leaders">
      <div class="alert alert-warning" v-if="error">{{ error }}</div>
      <div class="alert alert-success" v-if="success">{{ success }}</div>

      <appearances-drafts-header :appearances="appearances" />

      <statistics v-if="statistics" :statistics="statistics" :appearances="appearances" />

      <round-tabs v-if="event" :tabs="event.rounds" :isEventPage="true" />

      <div v-if="entity.id" class="leaders-event__body" style="margin-top: 24px;">
        <ul class="leaders-event__main-row">
          <li class="col-1 tac leaderboard-sort"
            @click="changeSort('order')"
          >
            <div class="column_name"><span>Run</span></div>
            <div class="sort-icon"></div>
          </li>
          <li class="col-6 col-mob-9 display-md">Info</li>
          <li class="col-2 hidden-md leaderboard-sort"
            @click="changeSort('rider_name')"
          >
            <div class="column_name mx-0">Rider name</div>
            <div class="sort-icon"></div>
          </li>
          <li class="col-2 hidden-md">Horse name</li>
          <li class="col-1 hidden-md">Owner name</li>
          <li class="col-1 tac hidden-mob leaderboard-sort"
            @click="changeSort('cutout')"
          >
            <div class="column_name">Cutout</div>
            <div class="sort-icon"></div>
          </li>
          <li class="col-1 tac hidden-mob">
            <span style="overflow-wrap: break-word;">Horsework</span>
          </li>
          <li class="col-1 tac hidden-mob">Course</li>
          <li class="col-1 col-mob-2 tac leaderboard-sort"
            @click="changeSort('round_score')"
          >
            <div class="column_name">{{ event.rounds[selectedRound].name !== 'Final' ? 'Round' : 'Final' }} score</div>
            <div class="sort-icon"></div>
          </li>
          <li v-if="selectedRound > 0" class="col-1 col-mob-2 tac leaderboard-sort"
            @click="changeSort('previous_rounds_score')"
          >
            <div class="column_name">Previous rounds' score</div>
            <div class="sort-icon"></div>
          </li>
          <li v-if="selectedRound > 0" class="col-1 col-mob-2 tac leaderboard-sort"
            @click="changeSort('total_score')"
          >
            <div class="column_name">Total score</div>
            <div class="sort-icon"></div>
          </li>
        </ul>

        <div class="js-event-infinite">
          <ul v-for="draw in draws" :key="draw.id">
            <li class="col-1 tac">
              {{ draw.order }}
            </li>
            <li class="col-6 col-mob-9 display-md">
              <div><span>Rider name:</span>
                <link-rider v-if="entity.id" :draw="draw" />
              </div>
              <div><span>Horse name:</span> {{ draw.horse_name }}</div>
              <div><span>Owner name:</span> {{ draw.owner_name }}</div>
              <div class="display-mob leaders-event__scores">
                <div class="leaders-event__scores-item">
                  <span>Cutout</span> {{ draw.cutout !== null && draw.cutout !== undefined ? formatScore(draw.cutout) : '-' }}
                </div>
                <div class="leaders-event__scores-item">
                  <span>Horsework</span> {{ draw.work !== null && draw.work !== undefined ? formatScore(draw.work) : '-' }}
                </div>
                <div class="leaders-event__scores-item">
                  <span>Course</span> {{ draw.course !== null && draw.course !== undefined ? formatScore(draw.course) : '-' }}
                </div>
              </div>
            </li>
            <li class="col-2 hidden-md">
              <link-rider v-if="entity.id" :draw="draw"  />
            </li>
            <li class="col-2 hidden-md text-wrap">{{ draw.horse_name }}</li>
            <li class="col-1 hidden-md">{{ draw.owner_name }}</li>
            <li class="col-1 tac hidden-mob">{{ draw.cutout !== null && draw.cutout !== undefined ? formatScore(draw.cutout) : '-' }}</li>
            <li class="col-1 tac hidden-mob">{{ draw.work !== null && draw.work !== undefined ? formatScore(draw.work) : '-' }}</li>
            <li class="col-1 tac hidden-mob">{{ draw.course !== null && draw.course !== undefined ? formatScore(draw.course) : '-' }}</li>
            <li class="col-1 col-mob-2 tac">{{ draw.round_score !== null && draw.round_score !== undefined ? formatScore(draw.round_score) : '-' }}</li>
            <li v-if="selectedRound > 0" class="col-1 col-mob-2 tac">{{ draw.previous_rounds_score !== null && draw.previous_rounds_score !== undefined ? formatScore(draw.previous_rounds_score) : '-' }}</li>
            <li v-if="selectedRound > 0" class="col-1 col-mob-2 tac">{{ draw.total_score !== null && draw.total_score !== undefined ? formatScore(draw.total_score) : '-'  }}</li>
          </ul>

          <div v-if="!finished && !loading && draws.length" class="text-center py-3">
            <button type="button" class="btn btn-outline-primary" @click="fetchEvent">Load more</button>
          </div>

          <div ref="infiniteTrigger"></div>

          <div v-if="loading" class="text-center py-3">
            Loading...
          </div>
        </div>
      </div>

      <div class="footer">
        <!-- need add banner -->
      </div>
    </div>
  </listing-layout>
</template>

<script>
import listingLayout from '@/components/ListingLayout'
import getAppearances from './mixins/getAppearances'
import AppearancesDraftsHeader from './components/AppearancesDraftsHeader'
import AppearancesDraftsDesktopBanner from './components/AppearancesDraftsDesktopBanner'
import getStatistics from './mixins/getStatistics'
import Statistics from './components/Statistics'
import RoundTabs from './components/RoundTabs'
import fetchData from '../../../mixins/apiHelpers'
import LinkRider from './components/Links/LinkRider'
import formatScore from './mixins/formatScore'

export default {
  name: 'LeadersEvent',
  mixins: [getAppearances, getStatistics, formatScore],
  props: ['success'],
  computed: {
    entity() {
      return {
        model: 'event',
        id: (this.event) ? this.event.draft_id : null,
        event_id: this.$route.params.main_event_id
      }
    },
    computedColor() {
      return this.appearances && this.appearances.schema_color
        ? `${this.appearances.schema_color}`
        : 'var(--primary)'
    },
    selectedRound() {
      return this.$route.params.round || 0
    },
    sortQuery() {
      return this.$route.query.sort || null
    },
    dirQuery() {
      return this.$route.query.dir || 'asc'
    }
  },
  watch: {
    '$route.params.main_event_id': {
      immediate: false,
      handler() {
        this.statistics = null
        this.fetchStatistics()
      }
    },
    '$route.query': {
      immediate: true,
      handler() {
        this.resetAndFetch()
      }
    }
  },
  components: {
    AppearancesDraftsHeader,
    AppearancesDraftsDesktopBanner,
    'listing-layout': listingLayout,
    Statistics,
    'round-tabs': RoundTabs,
    'link-rider': LinkRider
  },
  data() {
    return {
      event: null,
      draws: [],
      error: null,
      page: 1,
      loading: false,
      finished: false
    }
  },
  provide() {
    const self = this
    return {
      get entity() {
        return {
          model: 'event',
          id: self.event ? self.event.draft_id : null,
          event_id: self.$route.params.main_event_id
        }
      }
    }
  },
  methods: {
    // IntersectionObserver only reports visibility *changes*, so a hit that
    // arrives while a page is loading (or batched behind an older entry) is
    // lost and the list stalls until the user scrolls away and back. Measure
    // the distance to the trigger directly on scroll and after every page.
    loadMoreIfNeeded() {
      const trigger = this.$refs.infiniteTrigger
      if (!trigger || this.loading || this.finished || this.error) return

      if (trigger.getBoundingClientRect().top <= window.innerHeight + 300) {
        this.fetchEvent()
      }
    },
    resetAndFetch() {
      this.page = 1
      this.draws = []
      this.finished = false
      this.fetchEvent()
    },
    async fetchEvent() {
      if (this.loading || this.finished) return

      this.loading = true

      const query = new URLSearchParams()

      if (this.sortQuery) {
        query.append('sort', this.sortQuery)
        query.append('dir', this.dirQuery)
      }

      query.append('page', this.page)

      const subEventPart = this.$route.params.sub_event_id
        ? `/${this.$route.params.sub_event_id}`
        : ''

      await fetchData(
        `${this.$api}/leaders/events/${this.$route.params.main_event_id}/${this.$route.params.round}${subEventPart}?${query.toString()}`,
        (response) => {
          const event = response.data.data.event
          const newDraws = response.data.data.draws

          this.event = event

          if (!newDraws.length) {
            this.finished = true
          } else {
            this.draws.push(...newDraws)
            this.page++
          }

          if (!this.statistics) {
            this.fetchStatistics()
          }

          this.$root.$emit('update-breadcrumb', {
            name: 'Draft',
            link: `leaders/drafts/${this.event.draft_id}`
          })
        },
        this
      )

      this.loading = false
      this.$nextTick(this.loadMoreIfNeeded)
    },
    changeSort(column) {
      let dir = 'asc'

      if (this.sortQuery === column) {
        dir = this.dirQuery === 'asc' ? 'desc' : 'asc'
      }

      this.$router.push({
        query: {
          ...this.$route.query,
          sort: column,
          dir
        }
      })
    }
  },
  mounted() {
    window.addEventListener('scroll', this.loadMoreIfNeeded, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.loadMoreIfNeeded)
  }
}
</script>
<style scoped>
  .leaders a {
    color: var(--apperances-color) !important;
  }

  .nominate__title {
    color: var(--apperances-color) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Leaders/Listing/Event.vue